export const DashboardPlusicon = ({
  primaryFontColor = 'var(--primary-bg-color)',
  color = 'var(--primary-background-text-color',
  width = '48',
  height = '48',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 48 48"
    >
      <g
        id="Group_41546"
        data-name="Group 41546"
        transform="translate(-122 -164)"
      >
        <g id="Group_41501" data-name="Group 41501">
          <g
            id="Group_41477"
            data-name="Group 41477"
            transform="translate(-1372 -4)"
          >
            <circle
              id="Ellipse_1248"
              data-name="Ellipse 1248"
              cx="24"
              cy="24"
              r="24"
              transform="translate(1494 168)"
              fill={primaryFontColor}
            />
          </g>
        </g>
        <g id="plus_1_" data-name="plus (1)" transform="translate(73 138)">
          <path
            id="Path_63893"
            data-name="Path 63893"
            d="M16.418,7.418H10.582V1.582a1.582,1.582,0,1,0-3.164,0V7.418H1.582a1.582,1.582,0,1,0,0,3.164H7.418v5.836a1.582,1.582,0,1,0,3.164,0V10.582h5.836a1.582,1.582,0,1,0,0-3.164Z"
            transform="translate(64 41)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};
